<script setup lang="ts">
import { toRef } from 'vue';

import VLoader from '@components/loader/VLoader.vue';
import VFormPlainDataListbox from '@modules/forms/components/inputs/VFormPlainDataListbox/VFormPlainDataListbox.vue';
import VForm from '@modules/forms/components/VForm/VForm.vue';

import type { IEditRoleFormEmits, IEditRoleFormProps } from './types';
import { useRoleEditForm } from './composables';

const props = defineProps<IEditRoleFormProps>();
const emit = defineEmits<IEditRoleFormEmits>();

const {
  isAddColumnLoading,
  isRemoveColumnLoading,
  isReportFieldsPermitted,
  reportFieldsPayload,
  isReportNamesLoading,
  isReportFieldsLoading,
  formSchema,
  groups,
  reportFieldsData,
  translate,
  handleFormChange,
  handleReportColumnsChange,
} = useRoleEditForm(toRef(props, 'namespace'), toRef(props, 'createdRoleId'), emit);
</script>

<template>
  <div v-data-qa-auto-id="'VRoleEditForm'" class="max-w-[450px]">
    <VForm
      :schema="formSchema"
      :groups="groups"
      @change="handleFormChange"
    />
    <div
      v-if="isReportFieldsPermitted && !!reportFieldsPayload && !isReportNamesLoading"
      class="mt-5"
    >
      <VLoader
        :loading="isReportFieldsLoading"
        min-height="365px"
      >
        <VFormPlainDataListbox
          :label="translate('EDIT_SUB_HEADER_FIELDS')"
          :data="reportFieldsData?.fields"
          :translation-path="`${reportFieldsData?.locale_key}.`"
          :disabled="isAddColumnLoading || isRemoveColumnLoading"
          sort-after-change-item
          @change="handleReportColumnsChange"
        />
      </VLoader>
    </div>
  </div>
</template>
